import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  Router,
  withInMemoryScrolling,
  withPreloading,
} from "@angular/router";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import * as Sentry from "@sentry/angular";
import { ResponseLoggerInterceptor } from "blu-utilities/lib/interceptors/response-logger.interceptor";
import { QuicklinkStrategy } from "ngx-quicklink";
import { environment } from "../environments/environment";
import { appRoutes } from "./app.routes";
import { BlobErrorHttpInterceptor } from "./core/interceptors/blob-error.interceptor";
import { EncodeHttpParamsInterceptor } from "./core/interceptors/encode-params.interceptor";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { ParamsInterceptor } from "./core/interceptors/params.interceptor";
import { TokenInterceptor } from "./core/interceptors/token.interceptor";
import { AuthCoordinatorService } from "./modules/authentication/services/auth-coordinator.service";
import { BASE_ENVIRONMENT } from "blu-utilities";

export const appConfig: ApplicationConfig = {
  providers: [
    // Date Time Picker
    importProvidersFrom([OwlDateTimeModule, OwlNativeDateTimeModule]),

    // HTTP Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: ParamsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseLoggerInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BlobErrorHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true,
    },

    // Sentry Error Handling
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    // Environment
    {
      provide: BASE_ENVIRONMENT,
      useValue: environment,
    },

    // Auth Coordinator Service
    provideAppInitializer(() => {
      inject(AuthCoordinatorService).initialize();
    }),

    // Routing
    provideRouter(
      appRoutes,
      withPreloading(QuicklinkStrategy),
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
    ),

    // Change Detection
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Animations and HTTP Client
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
